<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-12-23 10:57:20
-->
<template>
  <li
    @mousedown="handleClick"
    :class="this.disabled ? 'disabled' : null"
    :title="titleText"
  >
    <slot></slot>
  </li>
</template>

<script>
import { ElDispatch } from "../../../utils/ElementEmitter";
import ShortcutBase from "./shortcutBase";
export default {
  props: {
    command: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: String,
  },
  mixins: [ShortcutBase],
  data() {
    return {
      shortcutMoment: "keydown",
    };
  },
  methods: {
    ElDispatch,
    handleClick() {
      if (this.disabled) return;
      this.ElDispatch("ribbonDropMenu", "item-click", this.command);
    },
  },
  computed: {
    titleText() {
      return this.title || this.shortcutTitle;
    },
    shortcutHandler() {
      return this.handleClick;
    },
  },
};
</script>

<style>
</style>